/* Amberton brand pages: reveal-on-scroll, photo strips, series tabs, book picker. No dependencies. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rv = document.querySelectorAll('.ab-rv');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { el.classList.add('ab-rv--on'); io.observe(el); });
  }

  document.querySelectorAll('[data-strip]').forEach(function (b) {
    b.addEventListener('click', function () {
      var s = b.closest('.ab-w').querySelector('.ab-strip');
      s.scrollBy({ left: Number(b.dataset.strip) * s.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  document.querySelectorAll('.ab-tabs').forEach(function (t) {
    var btns = t.querySelectorAll('[data-tab]'), panes = t.querySelectorAll('[data-pane]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        panes.forEach(function (p) { p.hidden = p.dataset.pane !== b.dataset.tab; });
      });
    });
  });

  document.querySelectorAll('[data-quiz]').forEach(function (q) {
    var res = q.querySelector('.ab-quiz__r'), ask = q.querySelector('.ab-quiz__a'), qq = q.querySelector('.ab-quiz__q');
    q.querySelectorAll('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        res.querySelectorAll('[data-res]').forEach(function (r) { r.hidden = r.dataset.res !== b.dataset.pick; });
        res.hidden = false; ask.hidden = true; qq.hidden = true;
      });
    });
    q.querySelectorAll('.ab-quiz__again').forEach(function (b) {
      b.addEventListener('click', function () { res.hidden = true; ask.hidden = false; qq.hidden = false; });
    });
  });
})();
